module.exports = __webpack_public_path__ + "assets/af397472051b1b382fecb0b479c853ec.svg";